import { Typography, useTheme } from "@mui/material";
import { BACKEND_URL } from '../../state/constants';
import FlexBetween from "components/FlexBetween";
import WidgetWrapper from "components/WidgetWrapper";

const AdvertWidget = () => {
  const { palette } = useTheme();
  const dark = palette.neutral.darkest;
  const main = palette.neutral.main;
  const medium = palette.neutral.deep;

  const imageUrl = "/uploads/posts/BambooAirways.jpg";
  const website = "bambooairways.com";

  return (
    <WidgetWrapper>
      <FlexBetween>
        <Typography color={dark} variant="h5" fontWeight="500">
          Sponsored
        </Typography>
        <Typography color={medium}>Advertisement</Typography>
      </FlexBetween>
      <img
        width="100%"
        height="auto"
        alt="advertisement"
        src={BACKEND_URL + imageUrl}
        style={{ borderRadius: "0.75rem", margin: "0.75rem 0" }}
        onError={(e) => {
          e.target.onerror = null; // prevents looping
          e.target.src = "/assets/VietnamFlag.png"; // provide a fallback image
        }}
      />
      <FlexBetween>
        <Typography color={main}>Website:</Typography>
        <Typography color={main}>
          <a 
            href={`https://${website}`} 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: dark, textDecoration: 'none' }}
          >
            {website}
          </a>
        </Typography>
      </FlexBetween>      
    </WidgetWrapper>
  );
};

export default AdvertWidget;
